import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { RootState } from '../store'

const TYPES = {
  TITLE: 'TITLE',
  DUE_DATE: 'DUE_DATE',
  STATUS: 'STATUS',
  TYPE: 'TYPE',
  PRIORITY: 'PRIORITY',
  CATEGORY: 'CATEGORY'
}

export type TypesType = keyof typeof TYPES

const DEFAULT_STATE: Record<TypesType, boolean> = {
  TITLE: false,
  DUE_DATE: false,
  STATUS: false,
  TYPE: false,
  PRIORITY: false,
  CATEGORY: false
}

type TaskInputState = {
  inputState: Record<string, Record<TypesType, boolean>>
}

const initialState: TaskInputState = {
  inputState: {}
}

export const taskInput = createSlice({
  name: 'taskInput',
  initialState,
  reducers: {
    setOpen: (
      state,
      action: PayloadAction<{
        key: string
        type: TypesType
        open: boolean
      }>
    ) => {
      const { key, type, open } = action.payload

      state.inputState[key] = {
        ...(state.inputState[key] ?? DEFAULT_STATE),
        [type]: open
      }
    }
  }
})

export const { setOpen } = taskInput.actions

export const selectTaskInput = (state: RootState) => state.taskInput

export default taskInput.reducer
